module.exports = __webpack_public_path__ + "img/3.bbeda8e3.jpg";